import { useState } from "react";
import type { FaqItem } from "@/types/content";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(defaultOpen);

  const toggle = (index: number) => {
    setActiveIndex((current) => (current === index ? null : index));
  };

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = activeIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                  {item.q}
                </span>
                <i
                  className={`shrink-0 text-xl transition-transform duration-300 ${
                    isOpen ? "ri-subtract-line rotate-180 text-primary-600" : "ri-add-line text-foreground-500"
                  }`}
                  aria-hidden="true"
                />
              </button>
            </h3>
            {isOpen && (
              <div className="px-5 pb-5 md:px-6">
                <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}